document.addEventListener('DOMContentLoaded', () => {
    // observed elem
    const elem = document.querySelector('.conditions__icons');

    const io = new IntersectionObserver((entries) => {
       entries.forEach(entry => {
           if (entry.isIntersecting) entry.target.classList.add('conditions__icons_inline');
       });
    });

   io.observe(elem);
});